/**
 * @return scenario type of the search table query, undefined if the the table query is not of search type
 */
export default function getSearchScenarioType(tableQuery) {
    var searchTableQuery = tableQuery;
    return tableQuery.type == 1 /* Search */ ? searchTableQuery.scenarioType : undefined;
}
//# sourceMappingURL=getSearchScenarioType.js.map